import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const THERAPIES_SPONSORS_ROLES = ['sundial-role:T_SPONSOR_PORTAL_BASE_USER', 'sundial-role:T_SPONSOR_NEXT_BASE_USER'];

export const therapiesSponsorsApplication = {
  name: ApplicationNames.THERAPIES_SPONSORS,
  url: envConfig.apps.therapiesSponsors,
  roles: THERAPIES_SPONSORS_ROLES,
};
